import React from 'react';
import './advantages.scss';

export function Advantages() {
  return (
    <div className="container margin_120_95">
      <div className="main_title">
        <h2>Почему именно у нас</h2>
        <p>
          Почему среди всего разнообразия медицинский учреждений выбирают именно
          нас.
        </p>
      </div>
      <div className="row">
        <div className="col-lg-4 col-md-6">
          <a className="box_feat_about" href="#0">
            <i className="pe-7s-id" />
            <h3>Более 10 Врачей</h3>
            <p>
              Возможность, выбрать подходящего врача из списка предложенных.
            </p>
          </a>
        </div>
        <div className="col-lg-4 col-md-6">
          <a className="box_feat_about" href="#0">
            <i className="pe-7s-tools" />
            <h3>Современное оборудование</h3>
            <p>
              Качественное современное оборудование: аппарат УЗИ alpha 6, холтер
              ЭКГ и АД, лор-установка, лимфамат.
            </p>
          </a>
        </div>
        <div className="col-lg-4 col-md-6">
          <a className="box_feat_about" href="#0">
            <i className="pe-7s-date" />
            <h3>Оперативно</h3>
            <p>
              Запись по телефону. Возможность обследования в момент обращения,
              без очередей.
            </p>
          </a>
        </div>
        <div className="col-lg-4 col-md-6">
          <a className="box_feat_about" href="#0">
            <i className="pe-7s-headphones" />
            <h3>Консультация по телефону</h3>
            <p>Возможность получить интересующую информацию по телефону.</p>
          </a>
        </div>
        <div className="col-lg-4 col-md-6">
          <a className="box_feat_about" href="#0">
            <i className="pe-7s-cash" />
            <h3>Доступные цены</h3>
            <p>
              Услуги по приемлемым ценам, разные способы оплаты, работа по
              страховым полисам, продленный график работы кассы.
            </p>
          </a>
        </div>
        <div className="col-lg-4 col-md-6">
          <a className="box_feat_about" href="#0">
            <i className="pe-7s-map-2" />
            <h3>Центр города</h3>
            <p>
              Расположение в историческом центре города, хорошее транспортное
              сообщение.
            </p>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Advantages;
